import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { List, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useMeContext } from '~/modules/me';
import { useGetResourceMatchRowData } from '../hooks';
import RESOURCE_MATCH_POPOVER_BUTTON_ACTION from '../enum';
import ResourceMatchListRow from './ResourceMatchListRow';
import ResourceMatchListLoading from './ResourceMatchListLoading';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(0)
  },
  alternativesText: {
    margin: theme.spacing(1, 0)
  }
}));

export const ResourceMatchList = ({
  resourceRequest,
  onClose,
  allocationChartRef,
  buttonType,
  project
}) => {
  const classes = useStyles();

  const { formatMessage } = useIntl();
  const me = useMeContext();
  const {
    featureFlags: { isPsaPraaResourceMatchingEnabled }
  } = me;
  const { loading, userResourceMatchesMap } = useGetResourceMatchRowData({
    resourceRequestUri: resourceRequest.id
  });

  if (!loading && userResourceMatchesMap.length === 0) return null;

  const [firstMatch, ...rest] = userResourceMatchesMap;

  return loading ? (
    <ResourceMatchListLoading />
  ) : (
    <>
      <List data-qe-id="resourceMatchList" className={classes.root}>
        <ResourceMatchListRow
          key={firstMatch.resourceMatch.id}
          me={me}
          resourceRequest={resourceRequest}
          resourceMatch={firstMatch.resourceMatch}
          user={firstMatch.user}
          onClose={onClose}
          allocationChartRef={allocationChartRef}
          buttonType={buttonType}
          isPsaPraaResourceMatchingEnabled={isPsaPraaResourceMatchingEnabled}
          project={project}
        />
      </List>
      {(!isPsaPraaResourceMatchingEnabled || rest.length > 0) && (
        <>
          <Typography className={classes.alternativesText} variant="subtitle1">
            {formatMessage({
              id: 'resourceMatchPopover.delaAIsTopAlternatives'
            })}
          </Typography>
          <List
            data-qe-id="resourceMatchList_Alternatives"
            className={classes.root}
          >
            {rest.map(userResourceMatch => (
              <ResourceMatchListRow
                key={userResourceMatch.resourceMatch.id}
                me={me}
                resourceRequest={resourceRequest}
                resourceMatch={userResourceMatch.resourceMatch}
                user={userResourceMatch.user}
                onClose={onClose}
                allocationChartRef={allocationChartRef}
                buttonType={buttonType}
                isPsaPraaResourceMatchingEnabled={
                  isPsaPraaResourceMatchingEnabled
                }
                project={project}
              />
            ))}
          </List>
        </>
      )}
    </>
  );
};

ResourceMatchList.propTypes = {
  resourceRequest: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  allocationChartRef: PropTypes.object,
  buttonType: PropTypes.oneOf([
    RESOURCE_MATCH_POPOVER_BUTTON_ACTION.ACCEPT,
    RESOURCE_MATCH_POPOVER_BUTTON_ACTION.PROPOSE
  ]).isRequired,
  project: PropTypes.object.isRequired
};

export default ResourceMatchList;
